import { CaretRightOutlined, RightOutlined } from "@ant-design/icons";
import {
    Collapse,
    Row,
    Col,
    Steps,
    Button,
    message,
    Form,
    Input,
    Image,
    Carousel,
    Card,
    Divider,
    Select,
    DatePicker,
    Radio,
    Checkbox,
    Space,
    Avatar,
    Spin,
    Tag
} from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import accountService from "../../../api/account.service";

import { ADD_MODE, DATE_FORMAT_DMY_SLASH, EDIT_MODE, SAVE_SUCCESS_MSG, SUCCESS_STATUS, UPDATE_SUCCESS_MSG } from "../../../utility/Constants";
import ModalWithMessageAndAction from "../../common/ModalWithMessageAndAction";

// import RegistrationService from "../../api/registration.service";
// import commonUtility from "../../utility/Utils";
// import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from "../../utility/Constants";
// import { useParams } from "react-router-dom";
// import ProgrammeService from "../../api/programme.service";
 import moment from "moment";
import commonUtility from "../../../utility/Utils";
import { PRINT_BASE_URL } from "../../../utility/URL";
// import occupationService from "../../api/occupation.service";
const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;




const defaultFormValues = {
    voucher_id: 0,
    voucher_no: "",
    voucher_date: "",
    mode: "ADD",
    cheque_number: "",
    cheque_date: "",
    narration:"",
    dr_ac_id:"",
    dr_amount:0,
    cr_ac_id:"",
    cr_amount:0,
};




const ContraVoucherEntryView = () => {

    const [accountList, setAccountList] = useState([]);


    const [form] = Form.useForm();
    const [openModal, setOpenModal] = useState(false);
    const [responseModalTitle, setResponseModalTitle] = useState("");
    const [responseModalMessage, setResponseModalMessage] = useState("");
    const [formErrorMessage, setFormErrorMessage] = useState("");
    const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);

    const [responseModal, setResponseModal] = useState({
        responseModalTitle: '',
        isOpenModal: false,
        listLink: '',
        addmoreLink: '',
        responseModalMessage: '',
        printReuired: false,
        printUrl:""
    });

    const params = useParams();

    const onContraVoucherSave = async (values) => {

            const dr_amount = values.dr_amount;
            const cr_amount = values.cr_amount;

        if(dr_amount > 0 && cr_amount > 0) {
            if(validateAmount()) {

                setResponseModal({
                    responseModalTitle: '',
                    isOpenModal: false,
                    listLink: '',
                    addmoreLink: '',
                    responseModalMessage: '',
                    printReuired: false,
                    printUrl:""
                });

                setSaveLoaderEnable(true)
                const data = { formdata: values };
                const response = accountService.contraVoucherSave(data).then((resdata) => {
    
    
                    if (resdata.response_data.mode == ADD_MODE) {
           
                        // setOpenModal(true)
                        // setResponseModalTitle("Success")
                        // setResponseModalMessage(`${SAVE_SUCCESS_MSG} with voucher no ${response.response_data.voucher_no}`)

                      //  console.log('response',response_data);
                      
                        const print_url = `${PRINT_BASE_URL}voucher/printpdf/${resdata.response_data.voucher_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`;

                        setResponseModal({
                            responseModalTitle: 'Success',
                            isOpenModal: true,
                            listLink: '/contravoucher/list',
                            addmoreLink: '/contravoucher/entry',
                            responseModalMessage: `${SAVE_SUCCESS_MSG} with voucher no ${resdata.response_data.voucher_no}`,
                            printReuired: true,
                            printUrl:print_url
                        });
                
                      }
                      else if(resdata.response_data.mode == EDIT_MODE) {
                        // setOpenModal(true)
                        // setResponseModalTitle("Success")
                        // setResponseModalMessage(`${UPDATE_SUCCESS_MSG}`)

                        const print_url = `${PRINT_BASE_URL}voucher/printpdf/${resdata.response_data.voucher_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`;

                        setResponseModal({
                            responseModalTitle: 'Success',
                            isOpenModal: true,
                            listLink: '/contravoucher/list',
                            addmoreLink: '/contravoucher/entry',
                            responseModalMessage: `${UPDATE_SUCCESS_MSG}`,
                            printReuired: true,
                            printUrl:print_url
                        });

                      }
    
                      setSaveLoaderEnable(false)
                
                });
            }
            else {
                setFormErrorMessage("Error : Debit and Credit amount must be same")
            }
        }
        else{
            setFormErrorMessage("Error : Debit or credit amount must be greater than 0")
        }
    };

    const handleCancel = () => {
        setOpenModal(false);
      };



    const validateAmount = () => {
        let dr_amount = form.getFieldValue("dr_amount");
        let cr_amount = form.getFieldValue("cr_amount");
        
        if(dr_amount != cr_amount) { return false;}
        return true;
    }

    const onChangeAmount = (tag) => {

        setFormErrorMessage("");
        
        let amount = 0;
        if (tag == "Dr") {
            amount = form.getFieldValue("dr_amount")
        }
        else {
            amount = form.getFieldValue("cr_amount")
        }

        form.setFieldsValue({
            dr_amount: amount,
            cr_amount: amount,
        })

    }



    const onVoucherDateChange = (date, dateString) => {
        form.setFieldsValue({
            voucher_date: dateString,
        });
    };
    
    
    const onChequeDateChange = (date, dateString) => {
        form.setFieldsValue({
            cheque_date: dateString,
        });
    };
    

    useEffect(() => {
        accountService.accountListForContra().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setAccountList(res.data.response_data);
            }

        });
    }, []);


    /**
     * 
     */

    useEffect(()=>{
        console.log("Voucher ID",params.voucher_id)

        if(params.voucher_id && params.voucher_id > 0) {

            const data = {
                formdata: {
                    voucher_master_id: params.voucher_id,
                },
              };
        
        
        
            accountService.contraVoucherEditByID(data).then((res) => {
        
                if (res.response_status === SUCCESS_STATUS) {
                    const voucher_data = res.response_data[0];

                    console.log("voucher_dat",voucher_data)
                    form.setFieldsValue({
                        mode: "EDIT",
                        voucher_no:voucher_data.voucher_no,
                        voucher_id:voucher_data.id,
                        //voucher_date_picker,
                        voucher_date: voucher_data.VoucherDate,
                        voucher_date_picker: voucher_data.VoucherDate ? moment( voucher_data.VoucherDate, DATE_FORMAT_DMY_SLASH) : '',

                        cheque_date:voucher_data.chequeDate,
                        cheque_date_picker: voucher_data.chequeDate ? moment( voucher_data.chequeDate, DATE_FORMAT_DMY_SLASH) : '',

                        cheque_number:voucher_data.cheque_number,
                        narration:voucher_data.narration,
                        dr_ac_id:voucher_data.dr_acc_id,
                        dr_amount:voucher_data.dr_amount,
                        cr_ac_id:voucher_data.cr_acc_id,
                        cr_amount:voucher_data.cr_amount
                    })
                }
            });

        }


    });



    return (
        <div>
            <div className="form-input-style">
                <Row
                    className="login-first-step-row"
                    style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
                >
                    <Col className="login-first-step-block-1" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onContraVoucherSave}
                            autoComplete="off"
                            initialValues={defaultFormValues}
                            className="basicRegForm"
                            style={{ padding: "10px 20px" }}
                        >

                            <Row gutter={20}>
                                <Col className="gutter-row" xs={24} xl={7}>
                                    <Form.Item name="voucher_no" label="Voucher No">
                                        <Input placeholder="" readOnly={true} />
                                    </Form.Item>

                                    <Form.Item name="mode" label="mode" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="voucher_id" label="vid" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={7}>
                                    <Form.Item name="voucher_date_picker" label="Voucher Date" rules={[
                                        {
                                            required: true,
                                            message: 'Voucher Date is required',
                                        },
                                    ]}>
                                        <DatePicker
                                            format="DD/MM/YYYY"
                                            // onChange={onDateOfBirthChange}
                                            onChange={onVoucherDateChange}
                                            style={{ width: "100%" }}
                                            inputReadOnly={true}
                                        />
                                    </Form.Item>
                                    <Form.Item name="voucher_date" label="Voucher Dt" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={20}>

                                <Col xs={24} xl={7}>
                                    <Form.Item name="cheque_number" label="Cheque No">
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>



                                <Col xs={24} xl={7}>
                                    <Form.Item name="cheque_date_picker" label="Cheque Date" >
                                        <DatePicker
                                            format="DD/MM/YYYY"
                                            // onChange={onDateOfBirthChange}
                                            onChange={onChequeDateChange}
                                            style={{ width: "100%" }}
                                            inputReadOnly={true}
                                        />
                                    </Form.Item>
                                    <Form.Item name="cheque_date" label="Chq Dt" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={20}>

                                <Col xs={24} xl={14}>
                                    <Form.Item name="narration" label="Narration">
                                        <TextArea rows={1} placeholder="" />
                                    </Form.Item>
                                </Col>




                            </Row>

                            <Row gutter={20}>
                                <Col xs={24} xl={7}>
                                    <Form.Item name="dr_ac_id" label="Account to be Debited"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please select account to be debited',
                                            },
                                        ]}
                                    >
                                        <Select
                                            className="text-left"
                                            showSearch
                                            placeholder="Search to Select"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().includes(input.toLowerCase())
                                            }
                                            filterSort={(optionA, optionB) =>
                                                optionA.children
                                                    .toLowerCase()
                                                    .localeCompare(optionB.children.toLowerCase())
                                            }
                                            allowClear={true}
                                        >

                                            {
                                                accountList.length > 0 ?
                                                    accountList.map(account_data => (
                                                        <Option key={account_data.id} value={account_data.id}>{account_data.account_name}</Option>

                                                    ))
                                                    : ''
                                            }
                                        </Select>

                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={7}>
                                    <Form.Item name="dr_amount" label="Debite Amount (Rs.)" 
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Enter debite Amount',
                                        },
                                    ]}
                                    onChange={() => onChangeAmount("Dr")}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>


                            </Row>

                            <Row gutter={20}>
                                <Col xs={24} xl={7}>
                                    <Form.Item name="cr_ac_id" label="Account to be Credited"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please select account to be credited',
                                        },
                                    ]}
                                    >
                                        <Select
                                            className="text-left"
                                            showSearch
                                            placeholder="Search to Select"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().includes(input.toLowerCase())
                                            }
                                            filterSort={(optionA, optionB) =>
                                                optionA.children
                                                    .toLowerCase()
                                                    .localeCompare(optionB.children.toLowerCase())
                                            }
                                            allowClear={true}
                                        >

                                            {
                                                accountList.length > 0 ?
                                                    accountList.map(account_data => (
                                                        <Option key={account_data.id} value={account_data.id}>{account_data.account_name}</Option>

                                                    ))
                                                    : ''
                                            }
                                        </Select>

                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={7}>
                                    <Form.Item name="cr_amount" label="Credit Amount (Rs.)" 
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Enter credit Amount',
                                        },
                                    ]}
                                    onChange={() => onChangeAmount("Cr")}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>


                            </Row>

                            <Row gutter={20}>
                                <Col xs={24} xl={12} >
                                    {
                                        formErrorMessage.length > 0 ? <><Tag color="error">{formErrorMessage}</Tag></> : ''
                                    }
                                    
                                </Col>
                                <Col xs={24} xl={2}>
                                    <Form.Item>
                                        {/* <Button htmlType="submit" className="custom-button-green" shape="round" style={{ margin: 8, border: 0 }}> Save <RightOutlined /></Button> */}





                                        {
                        isSaveLoaderEnable ? <Spin /> : <>
                           <Button htmlType="submit" className="custom-button-green" shape="round" style={{ margin: 8, border: 0 }}> Save <RightOutlined /></Button>
                        </>
                      }

                                    </Form.Item>
                                </Col>
                            </Row>





                        </Form>
                    </Col>

                </Row>
            </div>


            {/* <ModalWithMessageAndAction key={commonUtility.randomID()} responseModalTitle={responseModalTitle} openModal={openModal} handleCancel={handleCancel} listLink={'/contravoucher/list'} addmoreLink={'/contravoucher/entry'} responseModalMessage={responseModalMessage} /> */}
            {
                responseModal.isOpenModal ? <>
                    <ModalWithMessageAndAction responseModal={responseModal} />
                </> : <></>
            }


        </div>
    )
}

export default ContraVoucherEntryView